import { sanitize } from 'dompurify';

/**
 * Allows rendering simple html markup safely. The current use case is for translations
 * with basic formatting embedded such as with <b> or <i>.
 */
export default function TextWithMarkup({ text }) {
    return <span dangerouslySetInnerHTML={{ __html: sanitize(text) }} />;
}
